import { ActionGenerator, actionsGenerator } from 'store/utils';

export const SEARCH_POLICY = '@POLICIES/SEARCH_POLICY';

export const SEARCH_POLICY_ACTIONS: ActionGenerator = actionsGenerator(
  SEARCH_POLICY,
);
